import { USERINFO } from '@/utils/constant'

export type StorageDataType = 'localStorage' | 'sessionStorage'
export type formatType = 'json' | ''
export interface InitStorageOptions {
  type: StorageDataType
  format?: formatType
  verifyMobile?: boolean // 是否验证当前登录手机号
  once?: boolean // 是否只使用一次
}
export interface StorageInstance {
  getKey: () => string
  clear: () => void
  get<T = string>(): T | null
  set<T>(value: T | string): void
}
export const localStorageTypeStr = 'localStorage'
export const sessionStorageTypeStr = 'sessionStorage'

const initedStorageMap = {
  // 存储已经生成storage实例
}
function getCacheMobile(): string {
  const cacheData = sessionStorage.getItem(USERINFO)
  if (!cacheData) {
    return ''
  }
  try {
    const mobile = JSON.parse(cacheData).mobile
    return mobile
  } catch (error) {
    console.log('error', error)
    return ''
  }
}

export function initStorageInstance(key: string, options: InitStorageOptions): StorageInstance {
  const { type, verifyMobile, once } = options
  let storageApi: Storage

  if (type === 'localStorage') {
    storageApi = localStorage
  } else if (type === 'sessionStorage') {
    storageApi = sessionStorage
  }
  const result: StorageInstance = {
    getKey() {
      return key
    },
    clear() {
      storageApi?.removeItem(key)
    },
    get<T = string>(): T | null {
      const storageData = storageApi.getItem(key)
      if (storageData === null) {
        return null
      }
      const mobile = getCacheMobile()
      const parseData = JSON.parse(storageData)
      if (verifyMobile && parseData.mobile !== mobile) {
        return null
      }
      if (once) {
        this.clear()
      }
      return parseData.data
    },
    set<T>(value: T | string) {
      const mobile = getCacheMobile()
      const result = {
        mobile,
        data: value,
      }
      try {
        storageApi.setItem(key, JSON.stringify(result))
      } catch (error) {
        console.error('存储失败', error)
      }
    },
  }
  return result
}
